/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetAvailableCapturesRequest {
    instanceId: string;
    sessionId?: string;
}

export interface GetRawDataPayloadRequest {
    rawDataId: string;
    sessionId?: string;
}

export interface GetReplayPreviewRequest {
    instanceId: string;
    startTime: Date;
    endTime: Date;
    sessionId?: string;
}

export interface ReplaySingleCaptureRequest {
    rawDataId: string;
    mode?: ReplaySingleCaptureModeEnum;
    sessionId?: string;
}

export interface ReplayTimeRangeRequest {
    instanceId: string;
    startTime: Date;
    endTime: Date;
    mode?: ReplayTimeRangeModeEnum;
    sessionId?: string;
}

/**
 * IntegrationReplayApi - interface
 * 
 * @export
 * @interface IntegrationReplayApiInterface
 */
export interface IntegrationReplayApiInterface {
    /**
     * Lists all available raw data captures for replay
     * @summary Get available raw data captures
     * @param {string} instanceId Integration instance ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationReplayApiInterface
     */
    getAvailableCapturesRaw(requestParameters: GetAvailableCapturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Lists all available raw data captures for replay
     * Get available raw data captures
     */
    getAvailableCaptures(requestParameters: GetAvailableCapturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the raw JSON payload from blob storage for a specific capture
     * @summary Get raw data payload
     * @param {string} rawDataId Raw data capture ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationReplayApiInterface
     */
    getRawDataPayloadRaw(requestParameters: GetRawDataPayloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the raw JSON payload from blob storage for a specific capture
     * Get raw data payload
     */
    getRawDataPayload(requestParameters: GetRawDataPayloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Preview what would happen if raw data is replayed (DRY_RUN mode)
     * @summary Get replay preview
     * @param {string} instanceId Integration instance ID
     * @param {Date} startTime Start time (ISO 8601)
     * @param {Date} endTime End time (ISO 8601)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationReplayApiInterface
     */
    getReplayPreviewRaw(requestParameters: GetReplayPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Preview what would happen if raw data is replayed (DRY_RUN mode)
     * Get replay preview
     */
    getReplayPreview(requestParameters: GetReplayPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Reprocesses a single raw data capture for debugging
     * @summary Replay single raw data capture
     * @param {string} rawDataId Raw data capture ID
     * @param {'DRY_RUN' | 'FULL_REPLAY' | 'SINGLE_RECORD'} [mode] Replay mode (DRY_RUN, FULL_REPLAY)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationReplayApiInterface
     */
    replaySingleCaptureRaw(requestParameters: ReplaySingleCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Reprocesses a single raw data capture for debugging
     * Replay single raw data capture
     */
    replaySingleCapture(requestParameters: ReplaySingleCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Reprocesses raw data from specified time range using current transform rules
     * @summary Replay integration data by time range
     * @param {string} instanceId Integration instance ID
     * @param {Date} startTime Start time (ISO 8601)
     * @param {Date} endTime End time (ISO 8601)
     * @param {'DRY_RUN' | 'FULL_REPLAY' | 'SINGLE_RECORD'} [mode] Replay mode (DRY_RUN, FULL_REPLAY)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationReplayApiInterface
     */
    replayTimeRangeRaw(requestParameters: ReplayTimeRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Reprocesses raw data from specified time range using current transform rules
     * Replay integration data by time range
     */
    replayTimeRange(requestParameters: ReplayTimeRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationReplayApi extends runtime.BaseAPI implements IntegrationReplayApiInterface {

    /**
     * Lists all available raw data captures for replay
     * Get available raw data captures
     */
    async getAvailableCapturesRaw(requestParameters: GetAvailableCapturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getAvailableCaptures().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/replay/available-captures`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Lists all available raw data captures for replay
     * Get available raw data captures
     */
    async getAvailableCaptures(requestParameters: GetAvailableCapturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getAvailableCapturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the raw JSON payload from blob storage for a specific capture
     * Get raw data payload
     */
    async getRawDataPayloadRaw(requestParameters: GetRawDataPayloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['rawDataId'] == null) {
            throw new runtime.RequiredError(
                'rawDataId',
                'Required parameter "rawDataId" was null or undefined when calling getRawDataPayload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/replay/raw-data/{rawDataId}`;
        urlPath = urlPath.replace(`{${"rawDataId"}}`, encodeURIComponent(String(requestParameters['rawDataId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the raw JSON payload from blob storage for a specific capture
     * Get raw data payload
     */
    async getRawDataPayload(requestParameters: GetRawDataPayloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRawDataPayloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Preview what would happen if raw data is replayed (DRY_RUN mode)
     * Get replay preview
     */
    async getReplayPreviewRaw(requestParameters: GetReplayPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling getReplayPreview().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling getReplayPreview().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling getReplayPreview().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = (requestParameters['endTime'] as any).toISOString();
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/replay/preview`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Preview what would happen if raw data is replayed (DRY_RUN mode)
     * Get replay preview
     */
    async getReplayPreview(requestParameters: GetReplayPreviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getReplayPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reprocesses a single raw data capture for debugging
     * Replay single raw data capture
     */
    async replaySingleCaptureRaw(requestParameters: ReplaySingleCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['rawDataId'] == null) {
            throw new runtime.RequiredError(
                'rawDataId',
                'Required parameter "rawDataId" was null or undefined when calling replaySingleCapture().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/replay/single/{rawDataId}`;
        urlPath = urlPath.replace(`{${"rawDataId"}}`, encodeURIComponent(String(requestParameters['rawDataId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reprocesses a single raw data capture for debugging
     * Replay single raw data capture
     */
    async replaySingleCapture(requestParameters: ReplaySingleCaptureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.replaySingleCaptureRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reprocesses raw data from specified time range using current transform rules
     * Replay integration data by time range
     */
    async replayTimeRangeRaw(requestParameters: ReplayTimeRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['instanceId'] == null) {
            throw new runtime.RequiredError(
                'instanceId',
                'Required parameter "instanceId" was null or undefined when calling replayTimeRange().'
            );
        }

        if (requestParameters['startTime'] == null) {
            throw new runtime.RequiredError(
                'startTime',
                'Required parameter "startTime" was null or undefined when calling replayTimeRange().'
            );
        }

        if (requestParameters['endTime'] == null) {
            throw new runtime.RequiredError(
                'endTime',
                'Required parameter "endTime" was null or undefined when calling replayTimeRange().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['instanceId'] != null) {
            queryParameters['instanceId'] = requestParameters['instanceId'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = (requestParameters['startTime'] as any).toISOString();
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = (requestParameters['endTime'] as any).toISOString();
        }

        if (requestParameters['mode'] != null) {
            queryParameters['mode'] = requestParameters['mode'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/integrations/replay/time-range`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Reprocesses raw data from specified time range using current transform rules
     * Replay integration data by time range
     */
    async replayTimeRange(requestParameters: ReplayTimeRangeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.replayTimeRangeRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ReplaySingleCaptureModeEnum = {
    DryRun: 'DRY_RUN',
    FullReplay: 'FULL_REPLAY',
    SingleRecord: 'SINGLE_RECORD'
} as const;
export type ReplaySingleCaptureModeEnum = typeof ReplaySingleCaptureModeEnum[keyof typeof ReplaySingleCaptureModeEnum];
/**
 * @export
 */
export const ReplayTimeRangeModeEnum = {
    DryRun: 'DRY_RUN',
    FullReplay: 'FULL_REPLAY',
    SingleRecord: 'SINGLE_RECORD'
} as const;
export type ReplayTimeRangeModeEnum = typeof ReplayTimeRangeModeEnum[keyof typeof ReplayTimeRangeModeEnum];
